import { inspect } from 'util'

/**
 * json serializing (circular error 방지)
 * @param obj json 변환 객체
 */
export const safeStringify = (obj: any): string => {
  return inspect(obj)
}

/**
 * formating stringify
 * @param obj
 * @param space
 */
export const format = (obj: any, space: number = 4): string => {
  return JSON.stringify(obj, null, space)
}
